<template>
  <div 
    class="mt-8">
    <v-layout wrap>
      <v-flex>
        <!-- <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar> -->

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          v-if="dialog.delete"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Buka Blacklist Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin buka blacklist customer <b class="font-weight-bold black--text">{{ selected.blacklists[0].name }}</b> yang Anda pilih?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="toBlacklist()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Buka
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialog konfirmasi hapus semua jadwal -->
        <v-dialog v-model="dialog.deleteAllJadwal"
          @keydown.esc="dialog.deleteAllJadwal = false"
          v-if="dialog.deleteAllJadwal"
          width="450"
          persistent>
          <v-card 
            class="pa-6" style="border-radius: 4px;">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-18 font-weight-bold">
              
              <v-icon 
                size="28" 
                color="red" 
                class="mr-3">
                mdi-alert-circle
              </v-icon>
              Hapus Semua Jadwal

              <v-spacer/>

              <v-icon 
                @click="dialog.deleteAllJadwal = false"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin ingin menghapus <b class="font-weight-bold red--text">semua jadwal ({{ jadwalCustomer.length }} jadwal)</b> untuk customer 
              <b class="font-weight-bold primary--text">{{ selected.toBlacklist.length > 0 ? selected.toBlacklist[0].name : '' }}</b>?
              
              <div class="mt-3 pa-3" style="background: #FEF2F2; border-radius: 8px; border: 1px solid #FECACA;">
                <div class="d-flex align-start">
                  <v-icon size="18" color="red" class="mr-2 mt-1">mdi-information-outline</v-icon>
                  <span class="body-2 red--text text--darken-1">
                    Tindakan ini tidak dapat dibatalkan. Semua data jadwal customer ini akan dihapus secara permanen.
                  </span>
                </div>
              </div>

              <div v-if="message.errorDeleteJadwal.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.errorDeleteJadwal }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-card-actions
              class="pa-0 pt-4">
              <v-btn
                @click="dialog.deleteAllJadwal = false"
                :disabled="process.deleteAllJadwal"
                height="40"
                outlined
                color="#64748B"
                class="body-2 font-weight-medium text-capitalize mr-3"
                style="border: 1.5px solid #CBD5E1; border-radius: 8px;">
                <v-icon size="18" class="mr-1">mdi-close</v-icon>
                Batal
              </v-btn>

              <v-spacer/>

              <v-btn
                @click="deleteAllJadwal()"
                :loading="process.deleteAllJadwal"
                :disabled="process.deleteAllJadwal"
                height="40"
                elevation="0"
                color="red"
                class="body-2 font-weight-bold white--text text-capitalize"
                style="box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25); border-radius: 8px;">
                <v-icon 
                  v-if="!process.deleteAllJadwal"
                  size="18" 
                  class="mr-2">
                  mdi-delete-sweep
                </v-icon>
                <span v-if="!process.deleteAllJadwal">Ya, Hapus Semua</span>
                <span v-else>Menghapus...</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialog untuk tambah blacklist -->
        <v-dialog v-model="dialog.addBlacklist"
          @keydown.esc="dialog.addBlacklist = false"
          v-if="dialog.addBlacklist"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">

            <v-card-title 
              class="d-flex align-center pa-4 pb-2 text-right popup-header fs-20 font-weight-bold">
              
              Blacklist Customer

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.addBlacklist = false; dialog.fullscreen = false; selected.toBlacklist = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            <v-divider 
              class="mb-2"
              style="border-top: 1px solid #e0e0e0;"/>

            <v-card-text class="pa-4">
              <!-- Confirmation Message -->
              <div class="d-flex align-center mb-4">
                <v-icon 
                  size="24" 
                  color="#F59E0B" 
                  class="mr-3">
                  mdi-alert-circle-outline
                </v-icon>
                <div class="body-1 font-weight-regular text-first">
                  Apakah Anda yakin ingin memblacklist customer 
                  <b class="font-weight-bold primary--text">{{ selected.toBlacklist.length > 0 ? selected.toBlacklist[0].name : '' }}</b>?
                </div>
              </div>

              <!-- Tabs for Jadwal and Invoice -->
              <v-tabs
                v-model="tabBlacklist"
                background-color="transparent"
                color="#1814F3"
                slider-size="3"
                class="mb-4"
                @change="onTabBlacklistChange">
                <v-tab class="text-capitalize font-weight-medium">
                  <v-icon size="18" class="mr-2">mdi-calendar-clock</v-icon>
                  Jadwal
                  <v-chip 
                    v-if="jadwalCustomer.length > 0"
                    x-small
                    color="primary"
                    text-color="white"
                    class="ml-2">
                    {{ jadwalCustomer.length }}
                  </v-chip>
                </v-tab>
                <v-tab class="text-capitalize font-weight-medium">
                  <v-icon size="18" class="mr-2">mdi-file-document-outline</v-icon>
                  Invoice
                  <v-chip 
                    v-if="invoiceCustomer.length > 0"
                    x-small
                    color="orange"
                    text-color="white"
                    class="ml-2">
                    {{ invoiceCustomer.length }}
                  </v-chip>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tabBlacklist">
                <!-- Tab Jadwal -->
                <v-tab-item>
                  <!-- Table Card Jadwal -->
                  <v-card 
                    flat
                    class="jadwal-customer-card"
                    style="border-radius: 12px; border: 1px solid #E2E8F0; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);">

                    <!-- Header with Delete Button -->
                    <div 
                      v-if="!process.loadJadwalCustomer && jadwalCustomer.length > 0"
                      class="d-flex align-center justify-start pa-3"
                      style="border-bottom: 1px solid #E2E8F0;">
                      <v-btn
                        @click="dialog.deleteAllJadwal = true"
                        small
                        color="red"
                        outlined
                        class="text-capitalize"
                        style="border-radius: 8px;">
                        <v-icon small class="mr-1">mdi-delete-sweep</v-icon>
                        Hapus Semua Jadwal
                      </v-btn>
                    </div>

                    <v-card-text class="pa-0">
                      <!-- Loading State -->
                      <div v-if="process.loadJadwalCustomer" class="text-center py-12">
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          size="32"
                          width="3">
                        </v-progress-circular>
                        <div class="mt-4 body-2 text--secondary">
                          Memuat data jadwal customer...
                        </div>
                      </div>

                      <!-- Empty State -->
                      <div v-else-if="!process.loadJadwalCustomer && jadwalCustomer.length === 0" class="text-center py-12">
                        <v-img
                          class="mx-auto mb-4"
                          contain
                          alt="empty"
                          :width="120"
                          :height="120"
                          :src="require('@/assets/image/empty.png')">
                        </v-img>
                        <div class="subtitle-2 font-weight-medium text--secondary mb-1">
                          Tidak ada data jadwal
                        </div>
                        <div class="body-2 text--secondary">
                          Customer ini belum memiliki jadwal yang terdaftar
                        </div>
                      </div>

                      <!-- Table -->
                      <div v-else class="view">
                        <div v-if="!process.loadJadwalCustomer && jadwalCustomer.length > 0" class="jadwal-customer-table-wrapper">
                          <table class="jadwal-customer-table">
                            <thead>
                              <tr>
                                <th class="jadwal-customer-th text-center jadwal-customer-th-sticky">
                                  <div class="d-flex align-center justify-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-calendar</v-icon>
                                    <span>Tanggal</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-account</v-icon>
                                    <span>Customer</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-store</v-icon>
                                    <span>Toko</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-account-tie</v-icon>
                                    <span>Sales</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-calendar-week</v-icon>
                                    <span>Minggu</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-cash-multiple</v-icon>
                                    <span>Plafon</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-tag</v-icon>
                                    <span>Tipe Toko</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th" style="min-width: 450px; max-width: 450px;">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-map-marker</v-icon>
                                    <span>Alamat</span>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in jadwalCustomer" :key="index" :class="index === jadwalCustomer.length - 1 ? 'last-row' : ''">
                                <td class="jadwal-customer-td text-center jadwal-customer-td-sticky">
                                  <div class="jadwal-customer-date-wrapper">
                                    <div class="font-weight-medium">{{ item.date | date }}</div>
                                  </div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 150px; max-width: 150px;">
                                  <div class="jadwal-customer-recipient-name">{{ item.customer }}</div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 150px; max-width: 150px;">
                                  <div class="font-weight-medium">{{ item.store_name }}</div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 120px; max-width: 120px;">
                                  <v-chip 
                                    x-small
                                    color="blue lighten-5"
                                    text-color="blue darken-2"
                                    class="font-weight-medium">
                                    {{ item.sales }}
                                  </v-chip>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 100px; max-width: 100px;">
                                  <v-chip 
                                    x-small
                                    :color="item.minggu === 'Ganjil' ? 'purple lighten-5' : 'pink lighten-5'"
                                    :text-color="item.minggu === 'Ganjil' ? 'purple darken-2' : 'pink darken-2'"
                                    class="font-weight-medium">
                                    {{ item.minggu }}
                                  </v-chip>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 150px; max-width: 150px;">
                                  <div class="jadwal-customer-amount-primary font-weight-bold">
                                    {{ (item.customer_plafon*1) | price }}
                                  </div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 200px; max-width: 200px;">
                                  <div class="text-capitalize">{{ item.store_type }}</div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 450px; max-width: 450px;">
                                  <div class="d-flex align-start">
                                    <v-icon size="14" color="#94A3B8" class="mr-1 mt-1">mdi-map-marker-outline</v-icon>
                                    <span class="text--secondary">{{ item.store_village_name }}, {{ item.store_subdistrict_name }}, {{ item.store_city_name }}, {{ item.store_province_name }}</span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <!-- Tab Invoice -->
                <v-tab-item>
                  <!-- Table Card Invoice -->
                  <v-card 
                    flat
                    class="jadwal-customer-card"
                    style="border-radius: 12px; border: 1px solid #E2E8F0; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);">

                    <v-card-text class="pa-0">
                      <!-- Loading State -->
                      <div v-if="process.loadInvoiceCustomer" class="text-center py-12">
                        <v-progress-circular
                          indeterminate
                          color="orange"
                          size="32"
                          width="3">
                        </v-progress-circular>
                        <div class="mt-4 body-2 text--secondary">
                          Memuat data invoice customer...
                        </div>
                      </div>

                      <!-- Empty State -->
                      <div v-else-if="!process.loadInvoiceCustomer && invoiceCustomer.length === 0" class="text-center py-12">
                        <v-img
                          class="mx-auto mb-4"
                          contain
                          alt="empty"
                          :width="120"
                          :height="120"
                          :src="require('@/assets/image/empty.png')">
                        </v-img>
                        <div class="subtitle-2 font-weight-medium text--secondary mb-1">
                          Tidak ada data invoice
                        </div>
                        <div class="body-2 text--secondary">
                          Customer ini belum memiliki invoice yang terdaftar
                        </div>
                      </div>

                      <!-- Table Invoice -->
                      <div v-else class="view">
                        <div v-if="!process.loadInvoiceCustomer && invoiceCustomer.length > 0" class="jadwal-customer-table-wrapper">
                          <table class="jadwal-customer-table">
                            <thead>
                              <tr>
                                <th class="jadwal-customer-th text-center" style="min-width: 60px;">
                                  <span>No</span>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-file-document</v-icon>
                                    <span>No. Invoice</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-check-circle</v-icon>
                                    <span>Status</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-barcode</v-icon>
                                    <span>Kode Outlet</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-store</v-icon>
                                    <span>Nama Toko</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-account-tie</v-icon>
                                    <span>Sales</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-cash-multiple</v-icon>
                                    <span>Total</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-calendar-clock</v-icon>
                                    <span>Jatuh Tempo</span>
                                  </div>
                                </th>
                                <th class="jadwal-customer-th">
                                  <div class="d-flex align-center">
                                    <v-icon size="16" color="#64748B" class="mr-1">mdi-calendar</v-icon>
                                    <span>Tgl. Input</span>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in invoiceCustomer" :key="index" :class="index === invoiceCustomer.length - 1 ? 'last-row' : ''">
                                <td class="jadwal-customer-td text-center" style="min-width: 60px;">
                                  {{ index + 1 }}
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 150px;">
                                  <a :href="`/finance/invoice/detail/${item.id}`" target="_blank"> 
                                    <div class="font-weight-medium primary--text">{{ item.number }}</div>
                                  </a>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 120px;">
                                  <v-chip 
                                    x-small
                                    :color="item.status === 'lunas' ? 'green lighten-5' : item.status === 'pengajuan' ? 'orange lighten-5' : 'red lighten-5'"
                                    :text-color="item.status === 'lunas' ? 'green darken-2' : item.status === 'pengajuan' ? 'orange darken-2' : 'red darken-2'"
                                    class="font-weight-medium text-capitalize">
                                    {{ item.status === 'belum lunas' ? 'Belum Lunas' : item.status }}
                                  </v-chip>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 120px;">
                                  <div>{{ item.customer_code }}</div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 180px;">
                                  <div class="font-weight-medium">{{ item.store_name }}</div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 140px;">
                                  <v-chip 
                                    x-small
                                    color="blue lighten-5"
                                    text-color="blue darken-2"
                                    class="font-weight-medium">
                                    {{ item.sales_name }}
                                  </v-chip>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 140px;">
                                  <div class="jadwal-customer-amount-primary font-weight-bold">
                                    {{ calculateInvoiceTotal(item) | price }}
                                  </div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 130px;">
                                  <div :class="isOverdue(item.due_date) ? 'red--text font-weight-medium' : ''">
                                    {{ item.due_date | date }}
                                  </div>
                                </td>
                                <td class="jadwal-customer-td" style="min-width: 130px;">
                                  <div>{{ item.input_datetime | datetime }}</div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>

              <!-- Error Message -->
              <div v-if="message.error.length > 0" class="pa-4">
                <v-alert
                  type="error"
                  dense
                  outlined
                  class="mb-0">
                  <div class="d-flex align-center">
                    <v-icon size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span>{{ message.error }}</span>
                  </div>
                </v-alert>
              </div>
            </v-card-text>

            <v-card-actions
              class="pa-4 pt-3"
              style="border-top: 1px solid #E2E8F0;">
              <v-spacer/>

              <v-btn
                @click="dialog.addBlacklist = false; dialog.fullscreen = false; selected.toBlacklist = [];"
                :disabled="process.addBlacklist"
                height="42"
                width="100"
                elevation="0"
                outlined
                color="#64748B"
                class="body-2 font-weight-medium text-capitalize mr-3"
                style="border: 1.5px solid #CBD5E1; border-radius: 7px;">
                <v-icon size="18" class="mr-1">mdi-close</v-icon>
                Batal
              </v-btn>

              <v-btn
                @click="toAddBlacklist()"
                :loading="process.addBlacklist"
                :disabled="process.addBlacklist"
                height="42"
                width="160"
                elevation="0"
                color="#EF4444"
                class="body-2 font-weight-bold white--text text-capitalize blacklist-btn"
                style="box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25); border-radius: 7px;">
                <v-icon 
                  v-if="!process.addBlacklist"
                  size="18" 
                  class="mr-2">
                  mdi-alert-circle
                </v-icon>
                <span v-if="!process.addBlacklist">Ya, Blacklist</span>
                <span v-else>Memproses...</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialog untuk tampil data non-blacklist -->
        <v-dialog v-model="dialog.nonBlacklist"
          @keydown.esc="dialog.nonBlacklist = false"
          :fullscreen="dialog.fullscreen || $vuetify.breakpoint.smAndDown"
          :width="$vuetify.breakpoint.smAndDown ? '95%' : $vuetify.breakpoint.mdAndDown ? '85%' : '90%'"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 pb-2 text-right popup-header fs-20 font-weight-bold">
              
              Data Customer Non-Blacklist

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.nonBlacklist = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>

            <v-card-text class="pa-4">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">

                <v-col
                  cols="12"
                  md="12"
                  class="d-flex align-center">
                  <div v-if="$store.state.user.category_user_title !== 'Supervisor'">
                    <v-autocomplete
                      v-model="filterDataSupervisorNonBlacklist"
                      :items="supervisor"
                      item-text="name"
                      item-value="id"
                      clearable
                      @click:clear="filterDataSupervisorNonBlacklist = ''; changeFilterSupervisorNonBlacklist();"
                      hide-details
                      @change="changeFilterSupervisorNonBlacklist()"
                      filled
                      rounded
                      dense
                      class="fs-12 little-placeholder mr-3"

                      color="#718EBF"
                      placeholder="Nama Supervisor"

                      
                      :item-color="set_color"
                      style="border-radius: 6px; background: #d9e8ff9c !important; width: 220px">
                      <!-- <template v-slot:selection="{ item }">
                        <v-chip
                          v-if="item"
                          label
                          close
                          @click:close="filterDataSales = null">
                          {{ item.name }}
                        </v-chip>
                      </template> -->
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                        </template>
                      </template>

                    </v-autocomplete>
                  </div>
                  <div>
                    <v-autocomplete
                      v-model="filterDataSalesNonBlacklist"
                      :items="sales"
                      item-text="name"
                      item-value="name"
                      clearable
                      @click:clear="filterDataSalesNonBlacklist = ''; fetchNonBlacklist();"
                      hide-details
                      @change="fetchNonBlacklist()"
                      filled
                      rounded
                      dense
                      class="fs-12 little-placeholder"

                      color="#718EBF"
                      placeholder="Nama Sales"

                      
                      :item-color="set_color"
                      style="border-radius: 6px; background: #d9e8ff9c !important; width: 220px">
                      <!-- <template v-slot:selection="{ item }">
                        <v-chip
                          v-if="item"
                          label
                          close
                          @click:close="filterDataSales = null">
                          {{ item.name }}
                        </v-chip>
                      </template> -->
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                        </template>
                      </template>

                    </v-autocomplete>
                  </div>
                  <v-text-field
                    @click:clear="code_customerNonBlacklist = ''; fetchNonBlacklist();"
                    v-on:keyup.enter="fetchNonBlacklist()"

                    filled
                    rounded
                    dense
                    single-line

                    hide-details
                    :color="set_color"
                    placeholder="Kode Outlet"
                    append-icon="mdi-magnify"
                    clearable

                    v-model="code_customerNonBlacklist"
                    class="ml-3 fs-12 little-placeholder"
                    style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 190px">
                  </v-text-field>
                  <v-text-field
                    @click:clear="searchNonBlacklist = ''; fetchNonBlacklist();"
                    v-on:keyup.enter="fetchNonBlacklist()"

                    filled
                    rounded
                    dense
                    single-line

                    hide-details
                    :color="set_color"
                    placeholder="Cari data yang Anda butuhkan . . ."
                    append-icon="mdi-magnify"
                    clearable

                    v-model="searchNonBlacklist"
                    class="ml-3 fs-12 little-placeholder"
                    style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                  </v-text-field>
                </v-col>
                
                <div class="view">
                  <div v-if="!process.loadNonBlacklist" :class="process.loadNonBlacklist || listNonBlacklist.length === 0 ? '' : 'wrapper-dialog'">
                    <table :style="`border-radius: 10px; width: 100%; min-width: ${$vuetify.breakpoint.smAndDown ? '900px' : '100%'};`" class="table">
                      <tr>
                        <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Kode Outlet
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Nama Toko
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Nama Customer
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Alamat Toko
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tipe Toko
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Area
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tanggal Pengajuan
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Nama Sales
                        </th>
                      </tr>
                      <tr v-for="(item, index) in listNonBlacklist" :key="index" @click="selected.rowNonBlacklist = index" :class="selected.rowNonBlacklist === index ? 'selected' : ''">
                          <td class="sticky-col one-col d-flex align-center" 
                             :style="`font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center; min-height: ${$vuetify.breakpoint.smAndDown ? '60px' : '80px'}; max-height: ${$vuetify.breakpoint.smAndDown ? '80px' : '120px'};`">
                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                :to="`/customer/data/detail/${item.id}?menu=toko`"
                                min-width="28"
                                small
                                rounded
                                color="green"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon small>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Detail</span>
                          </v-tooltip> -->

                          <div v-if="user.category_user_id === '1'">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  min-width="28"
                                  small
                                  @click="confirmBlacklist(item)"
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-account-off</v-icon>
                                </v-btn>
                              </template>
                              <span>Blacklist</span>
                            </v-tooltip>
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          {{ item.activation_code }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          <a target="_blank" :href="`/customer/data/detail/${item.id}`">
                            {{ item.store_name }}
                          </a>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 300px; min-width: 300px; text-align: left;" class="text-lowercase">{{ item.store_province_name }}, {{ item.store_city_name }}, {{ item.store_subdistrict_name }}, {{ item.store_village_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;" class="text-capitalize">{{ item.store_type }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.sales_region !== null ? item.sales_region.sales_region_name : '-' }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 150px; min-width: 150px; text-align: left;">{{ (item.create_datetime) | datetime }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          {{ item.reg_by }}
                        </td>
                      </tr>
                    </table>
                  </div>

                  <v-card-text
                    v-if="process.loadNonBlacklist" 
                    class="pb-0 my-4" 
                    :style="`height: ${$vuetify.breakpoint.smAndDown ? 'calc(100vh - 300px)' : 'calc(100vh - 400px)'}; display: flex; align-items: center; justify-content: center;`">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>

                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>

                  <v-card-text
                    v-if="listNonBlacklist.length === 0 && !process.loadNonBlacklist"
                    class="pb-0 my-4" 
                    :style="`height: ${$vuetify.breakpoint.smAndDown ? 'calc(100vh - 300px)' : 'calc(100vh - 400px)'}; display: flex; align-items: center; justify-content: center;`">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data Non-Blacklist
                      </div>
                    </div>
                  </v-card-text>

                  <pagination v-if="!process.loadNonBlacklist && paginationNonBlacklist.total_data > 0"
                    @changePage="fetchNonBlacklist($event)" 
                    @reloadPage="fetchNonBlacklist($event)" 
                    :model="paginationNonBlacklist" :display="paginationListNonBlacklist"/>
                </div>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                <div class="body-2 mb-2">
                  Periode
                </div>

                <v-select
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. 2023"

                  :items="years"
                  :item-color="set_color"

                  v-model="filter.year"
                  style="border-radius: 10px;">
                </v-select>
              </div>

              <div>
                <div class="body-2 mb-2">
                  Bulan
                </div>

                <v-select
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Januari"

                  :items="months"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="filter.month"
                  style="border-radius: 10px;">
                </v-select>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Customer Proses
                    </span>
                  </div>

                  <v-spacer />

                  <div class="d-flex align-center">
                  </div>  
                </div>
              </v-card>
            </v-col>
          </v-row> -->

          <v-card 
            flat
            class="ma-4 mt-0 box-shadow"
            style="border-radius: 10px;">
            <v-row
              class="pa-4 py-0">
              <v-col
                cols="12"
                md="7">
                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Customer Blacklist
                </span>
                <!-- <div
                  class="body-2">
                  Perbandingan SP2D 

                  <span v-if="filter.year !== '' && filter.year !== null">
                    tahun <strong class="black--text">{{ filter.year }}</strong>
                  </span>

                  <span v-if="filter.month !== '' && filter.month !== null">
                    di bulan <strong class="black--text">{{ filter.month_text }}</strong>
                  </span>
                </div> -->
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="d-flex align-center">
                <div v-if="$store.state.user.category_user_title !== 'Supervisor'">
                  <v-autocomplete
                    v-model="filterDataSupervisor"
                    :items="supervisor"
                    item-text="name"
                    item-value="id"
                    clearable
                    @click:clear="filterDataSupervisor = ''; changeFilterSupervisor();"
                    hide-details
                    @change="changeFilterSupervisor()"
                    filled
                    rounded
                    dense
                    class="fs-12 little-placeholder mr-3"

                    color="#718EBF"
                    placeholder="Nama Supervisor"

                    
                    :item-color="set_color"
                    style="border-radius: 6px; background: #d9e8ff9c !important; width: 220px">
                    <!-- <template v-slot:selection="{ item }">
                      <v-chip
                        v-if="item"
                        label
                        close
                        @click:close="filterDataSales = null">
                        {{ item.name }}
                      </v-chip>
                    </template> -->
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                      </template>
                    </template>

                  </v-autocomplete>
                </div>
                <div>
                  <v-autocomplete
                    v-model="filterDataSales"
                    :items="sales"
                    item-text="name"
                    item-value="name"
                    clearable
                    @click:clear="filterDataSales = ''; fetch();"
                    hide-details
                    @change="fetch()"
                    filled
                    rounded
                    dense
                    class="fs-12 little-placeholder"

                    color="#718EBF"
                    placeholder="Nama Sales"

                    
                    :item-color="set_color"
                    style="border-radius: 6px; background: #d9e8ff9c !important; width: 220px">
                    <!-- <template v-slot:selection="{ item }">
                      <v-chip
                        v-if="item"
                        label
                        close
                        @click:close="filterDataSales = null">
                        {{ item.name }}
                      </v-chip>
                    </template> -->
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                      </template>
                    </template>

                  </v-autocomplete>
                </div>
                <v-text-field
                  @click:clear="code_customer = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line

                  hide-details
                  :color="set_color"
                  placeholder="Kode Outlet"
                  append-icon="mdi-magnify"
                  clearable

                  v-model="code_customer"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 190px">
                </v-text-field>
                <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line

                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-model="search"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field>
                <div class="ml-2" v-if="user.category_user_title === 'Super User' || user.category_user_title === 'General Manager'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="exports_excel()"
                        :loading="process.export_excel"
                        elevation="0"
                        dark
                        min-height="28"
                        small
                        min-width="28"
                        color="#097640"
                        class="text-capitalize px-0 white--text"
                        style="border-radius: 6px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18">mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Export Excel
                    </span>
                  </v-tooltip>
                </div>
                <div class="ml-2">
                  <v-tooltip 
                    top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="dialog.nonBlacklist = true; fetchNonBlacklist(); searchNonBlacklist = ''; code_customerNonBlacklist = ''; filterDataSalesNonBlacklist = ''; filterDataSupervisorNonBlacklist = '';"
                        v-bind="attrs"
                        v-on="on"
                        min-width="28"
                        small
                        rounded
                        color="red"
                        elevation="0"
                        class="white--text text-capitalize mx-1 px-0"
                        style="font-weight: 600; border-radius: 6px;">
                        <v-icon small>mdi-account-off</v-icon>
                      </v-btn>
                    </template>

                    <span>Data Non-Blacklist</span>
                  </v-tooltip>
                </div>

                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- HIDE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div> -->
              </v-col>
            </v-row>
            <v-row
              class="pa-4 pt-0">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  

                  <div class="view">
                    <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                      <table :style="`border-radius: 10px; width: 100%; min-width: ${$vuetify.breakpoint.smAndDown ? '800px' : '100%'};`" class="table">
                        <tr>
                          <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                          <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Kode Outlet
                            <span v-if="sortBy === 'name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th @click="sortBy !== 'store_name' ? toSort('store_name') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Nama Toko
                            <span v-if="sortBy === 'store_name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th @click="sortBy !== 'name' ? toSort('name') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Nama Customer
                            <span v-if="sortBy === 'name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Alamat Toko
                            <span v-if="sortBy === 'sales_region_name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th @click="sortBy !== 'store_type' ? toSort('store_type') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Tipe Toko
                            <span v-if="sortBy === 'store_type'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Area
                            <span v-if="sortBy === 'sales_region_name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th @click="sortBy !== 'create_datetime' ? toSort('create_datetime') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Tanggal Pengajuan
                            <span v-if="sortBy === 'create_datetime'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th @click="sortBy !== 'reg_by' ? toSort('reg_by') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Nama Sales
                            <span v-if="sortBy === 'reg_by'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>

                          <th @click="sortBy !== 'approved_supervisor_name' ? toSort('approved_supervisor_name') : toDesc();" style=" width: 1px; white-space: nowrap; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Approved by Supervisor
                            <span v-if="sortBy === 'approved_supervisor_name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th @click="sortBy !== 'approved_sales_manager_name' ? toSort('approved_sales_manager_name') : toDesc();" style=" width: 1px; white-space: nowrap; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Approved by Sales Manager
                            <span v-if="sortBy === 'approved_sales_manager_name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <th @click="sortBy !== 'approved_gm_name' ? toSort('approved_gm_name') : toDesc();" style=" width: 1px; white-space: nowrap; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                            Approved by General Manager
                            <span v-if="sortBy === 'approved_gm_name'">
                              <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                              <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                            </span>
                          </th>
                          <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                          <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                          <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                        </tr>
                        <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                          <td class="sticky-col one-col d-flex align-center" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center; min-height: 60px;">
                            <!-- <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  
                                  v-bind="attrs"
                                  v-on="on"
                                  :to="`/customer/data/detail/${item.id}?menu=toko`"
                                  min-width="28"
                                  small
                                  rounded
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-information-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Detail</span>
                            </v-tooltip> -->

                            <div>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="28"
                                    small
                                    @click="blacklists(item)"
                                    rounded
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-account-check</v-icon>
                                  </v-btn>
                                </template>
  
                                <span>Blacklist</span>
                              </v-tooltip>
                            </div>

                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                            {{ item.activation_code }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                            <a target="_blank" :href="`/customer/data/detail/${item.id}`">
                              {{ item.store_name }}
                            </a>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 300px; min-width: 300px; text-align: left;" class="text-lowercase">{{ item.store_province_name }}, {{ item.store_city_name }}, {{ item.store_subdistrict_name }}, {{ item.store_village_name }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;" class="text-capitalize">{{ item.store_type }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.sales_region !== null ? item.sales_region.sales_region_name : '-' }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 150px; min-width: 150px; text-align: left;">{{ (item.create_datetime) | datetime }}</td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                            {{ item.reg_by }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                            {{ item.approved_supervisor_name }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                            {{ item.approved_sales_manager_name }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                            {{ item.approved_gm_name }}
                          </td>
                          <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                          <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                            {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                            {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                          </td> -->
                        </tr>
                      </table>
                    </div>

                    <v-card-text
                      v-if="process.load" 
                      class="pb-0 my-4" 
                      style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-4 title">
                          Mohon Tunggu . . .
                        </div>

                        <v-progress-linear
                          :color="set_color"
                          indeterminate
                          rounded
                          height="10">
                        </v-progress-linear>
                      </div>
                    </v-card-text>

                    <v-card-text
                      v-if="list.length === 0"
                      class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="90"
                          :height="90"
                          :src="require('@/assets/image/empty.png')">
                          <!-- <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template> -->
                        </v-img>
                        <div class="mt-3 fs-16">
                          Belum Ada Data
                        </div>
                      </div>
                    </v-card-text>

                    <pagination v-if="!process.load && pagination.total_data > 0"
                      @changePage="fetch($event)" 
                      @reloadPage="fetch($event)" 
                      :model="pagination" :display="paginationList"/>

                  </div>
                  <!-- <v-data-table
                    v-model="selected.row"
                    ref="table-grid"
                    class="table-grid"
                    :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                    :show-select="checkbox"
                    :single-select="true"
                    :loading="process.load"
                    loading-text="Sedang memuat data . . ."
                    loader-height="5"
                    no-results-text="Belum ada data"
                    :options.sync="options"
                    :headers="configHeaders"
                    :items="list"
                    :items-per-page="100"
                    item-key="id"
                    @click:row="rowClick"
                    @toggle-select-all="handleToggleAll($event)"
                    @dblclick:row="doubleClick"
                    hide-default-footer>
                    <template
                      v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                      v-slot:[`item.${header.value}`]="{ value, index }">
                      <div
                        v-bind:key="header.value">
                        <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                          {{ rowFormat(header.format, value) }} 
                        </div>

                        <div v-if="header.format === 'link'"
                          class="cursor-pointer">
                          
                        </div>
          
                        <div v-if="header.format === 'regex'">
                          <span
                            class="two-line">
                            {{ rowFormat(header.format, value) }}
                          </span>
                        </div>
          
                        <div v-if="header.format === 'image'"
                          class="ma-4">
                          <v-avatar
                            size="60"
                            tile
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="kominfoklaten" 
                              :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </div>

                        <div v-if="header.format === 'image_potrait'"
                          class="ma-4">
                          <v-img 
                            contain
                            width="100"
                            height="125"
                            alt="kominfoklaten" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto"
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>

                        <div v-if="header.format === 'image_landscape'"
                          class="ma-4">
                          <v-img 
                            contain
                            width="200"
                            height="125"
                            alt="kominfoklaten" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto"
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>

                        <div v-if="header.format === 'action'">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="dialog.form = true; reset(index);"
                                
                                v-bind="attrs"
                                v-on="on"

                                min-width="28"
                                small
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon small>mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Ubah</span>
                          </v-tooltip>
                        
                        </div>

                        <div v-if="header.format === 'bool'"
                          class="d-flex align-center justify-center">
                          
                        </div>

                        <div v-if="header.format === 'status'"
                          class="d-flex justify-center">
                          
                        </div>
                      </div>
                    </template>

                    <template v-slot:[`item.index`]="{ index }">
                      {{ lastIndex + index }}
                    </template>

                    <v-progress-linear 
                      v-show="process.load" 
                      slot="progress" 
                      color="white" 
                      indeterminate>
                    </v-progress-linear>
                  </v-data-table> -->
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { get, post, put, patch, destroy } from "@/service/Axios";
import { TokenService } from "@/service/Storage.Service";
import moment from "moment"
import axios from "axios";
import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          filter: false,
          hide: false,
          freeze: false,
          fullscreen: false,
          form: false,
          formEdit: false,
          snackbar: false,
          delete: false,
          addBlacklist: false,
          nonBlacklist: false,
          deleteAllJadwal: false,
        },
        sortBy: 'id',
        sortDesc: '-',
        filter: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          month_text: ''
        },
        code_customer: '',
        filterDataSales: '',
        filterDataSupervisor: '',
        supervisor: [],
        search: '',
        salesAll: [],
        code_customerNonBlacklist: '',
        searchNonBlacklist: '',
        filterDataSalesNonBlacklist: '',
        filterDataSupervisorNonBlacklist: '',

        selected: {
          row: [],
          freeze: [],
          delete: [],
          blacklists: [],
          toBlacklist: [],
          rowNonBlacklist: 0
        },
        sales: [],
        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},
        paginationListStore: {},
        lastIndex: 0,
        limit: 50,
        listNonBlacklist: [],
        paginationNonBlacklist: {},
        paginationListNonBlacklist: {},
        jadwalCustomer: [],
        invoiceCustomer: [],
        tabBlacklist: 0,
        process: {
          load: false,

          form: false,

          delete: false,
          doc: false,
          export_excel: false,
          addBlacklist: false,
          loadNonBlacklist: false,
          loadJadwalCustomer: false,
          loadInvoiceCustomer: false,
          deleteAllJadwal: false
        },
        message: {
          success: '',
          error: '',
          errorDeleteJadwal: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'filter.year': function () {
      //   this.fetch()
      // },

      // 'filter.month': function () {
      //   let t = this

      //   let m = this.months.filter(function(v) {
      //     return t.filter.month == v.value
      //   })

      //   if (m.length > 0) {
      //     this.filter.month_text = m[0].text
      //   }
      // },
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // },
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      filter_customer () {
        return this.$store.state.customer
      },
      user () {
        return this.$store.state.user
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      }
    },
    mounted () {
      // this.filterDataSales = this.$store.state.customer.sales_id
      this.filterDataSales = this.$store.state.customer.sales_id !== '' ? this.$store.state.customer.sales_id : ''
      this.filterDataSupervisor = this.$store.state.customer.supervisor_id !== '' ? this.$store.state.customer.supervisor_id : ''
      this.paginationListStore = (Object.keys(this.$store.state.customer)).length === 0 ? {} : this.$store.state.customer.pagination
      if((Object.keys(this.paginationListStore)).length === 0) {
        this.fetch()
      } else {
        this.fetch(this.paginationListStore)
      }
      this.fetchSales()
      this.fetchSupervisor()
      this.fetchNonBlacklist()
    },
    methods: {
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetchSales () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '8',
          limit: 1000000,
          is_active: 'Aktif',
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : '',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            this.salesAll = res.results.data
            // console.log(this.filterDataSupervisor)
            if(this.filterDataSupervisor !== '' && this.filterDataSupervisor !== null && this.filterDataSupervisor !== undefined) {
              this.sales = this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisor)
            }
          }
          this.process.load = false
        })
      },


      async fetchJadwalCustomer () {
        this.process.loadJadwalCustomer = true

        let params = {
          customer_id: this.selected.toBlacklist[0].id,
          store_id: this.selected.toBlacklist[0].store_id,
          // store_id: '2164',
          pagination_bool: false
        }

        await get(`admin/jadwal/check_jadwal_customer`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.jadwalCustomer = res.results.data
            
          }
          this.process.loadJadwalCustomer = false
        })
      },

      async deleteAllJadwal () {
        this.message.errorDeleteJadwal = ''
        this.process.deleteAllJadwal = true

        // Collect all jadwal IDs
        const jadwalIds = this.jadwalCustomer.map(item => item.id)

        await post(`admin/jadwal/delete_by_customer`, {
          data: {
            // ids: jadwalIds,
            customer_id: this.selected.toBlacklist[0].id,
            // store_id: this.selected.toBlacklist[0].store_id
          }
        })
        .then(response => {
          let res = response.data
          
          this.process.deleteAllJadwal = false

          if (res.status === 200) {
            this.dialog.deleteAllJadwal = false
            this.jadwalCustomer = []
            
            // Show success message (optional - can use snackbar)
            this.message.success = res.message || 'Berhasil menghapus semua jadwal'
          } else {
            this.message.errorDeleteJadwal = res.message || 'Gagal menghapus jadwal'
          }
        })
        .catch(error => {
          this.process.deleteAllJadwal = false
          this.message.errorDeleteJadwal = 'Terjadi kesalahan saat menghapus jadwal'
        })
      },

      async fetchInvoiceCustomer () {
        this.process.loadInvoiceCustomer = true

        let params = {
          customer_id: this.selected.toBlacklist[0].id,
          pagination_bool: false,
          sort: '-id'
        }

        await get(`admin/customer_invoice/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.invoiceCustomer = res.results.data
          }
          this.process.loadInvoiceCustomer = false
        })
      },

      onTabBlacklistChange (tab) {
        if (tab === 1 && !this.process.loadInvoiceCustomer) {
          this.fetchInvoiceCustomer()
        } else if (tab === 0 && !this.process.loadJadwalCustomer) {
          this.fetchJadwalCustomer()
        }
      },

      calculateInvoiceTotal (item) {
        if (!item.orders_detail || item.orders_detail.length === 0) {
          return item.total * 1
        }
        const subtotal = item.orders_detail.reduce((sum, k) => sum + ((Math.round((k.price_per_pcs*1) * (k.total_in_dus*1)) * (k.qty_dus_diterima*1))), 0)
        const discount = item.orders_detail.reduce((sum, i) => sum + (i.discount*1), 0)
        const strata = item.orders_detail.reduce((sum, i) => sum + ((i.strata_nominal*1) * (i.qty_dus_diterima*1)), 0)
        return subtotal - discount - strata
      },

      isOverdue (dueDate) {
        if (!dueDate) return false
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const due = new Date(dueDate)
        due.setHours(0, 0, 0, 0)
        return due < today
      },

      async fetchSupervisor () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '5',
          limit: 1000000,
          is_active: 'Aktif',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supervisor = res.results.data
            
          }
          this.process.load = false
        })
      },

      changeFilterSupervisor (e) {
        this.filterDataSales = ''
        this.sales = this.filterDataSupervisor !== '' && this.filterDataSupervisor !== null && this.filterDataSupervisor !== undefined ? this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisor) : this.salesAll
        this.fetch()
      },

      changeFilterSupervisorNonBlacklist (e) {
        this.filterDataSalesNonBlacklist = ''
        this.sales = this.filterDataSupervisorNonBlacklist !== '' && this.filterDataSupervisorNonBlacklist !== null && this.filterDataSupervisorNonBlacklist !== undefined ? this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisorNonBlacklist) : this.salesAll
        this.fetchNonBlacklist()
      },

      async fetch (pagination = { row: 50, page: 1 }) {
        // console.log((Object.keys(this.$store.state.customer)).length)
        // this.filterDataSales = this.$store.state.customer.sales_id !== '' ? this.$store.state.customer.sales_id : this.filterDataSales
        
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = {
          page: pagination.page,
          row: pagination.row
        }

        let params = {
          // status: 'rejected',
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          'activation_code[lse]': this.code_customer,
          // create_datetime: this.filterDate,
          reg_by: this.filterDataSales,
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisor,
          is_blacklist: '1'
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/customer/data_approved`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: '',
                width: '150px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'start',
                format: 'action'
              },
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Tanggal Pengajuan',
                width: '200px',
                value: 'create_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Nama customer',
                width: '300px',
                value: 'name',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama Alias',
                width: '180px',
                value: 'name_alias',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Sales',
                width: '200px',
                value: 'reg_by',
                freeze: false,
                hide: false
              },
              
              // {
              //   text: 'Status',
              //   width: '150px',
              //   value: 'status',
              //   freeze: false,
              //   hide: false,
              //   format: 'status'
              // },
            
            ]
    
            this.list = res.results.data
            this.pagination = res.results.pagination
            // TokenService.saveCustomer(JSON.stringify(
            //   {
            //     sales_id: this.filterDataSales,
            //     search: this.search,
            //   }
            // ))
            this.$store.commit("setCustomer", 
              {
                sales_id: this.filterDataSales,
                search: this.search,
                pagination: this.paginationList,
                supervisor_id: this.filterDataSupervisor
              }
            )  

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1


            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      async fetchNonBlacklist (pagination = { row: 50, page: 1 }) {
        // console.log((Object.keys(this.$store.state.customer)).length)
        // this.filterDataSales = this.$store.state.customer.sales_id !== '' ? this.$store.state.customer.sales_id : this.filterDataSales
        
        this.process.loadNonBlacklist = true

        this.limit = pagination.row
        this.paginationListNonBlacklist = {
          page: pagination.page,
          row: pagination.row
        }

        let params = {
          // status: 'rejected',
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.searchNonBlacklist,
          'activation_code[lse]': this.code_customerNonBlacklist,
          // create_datetime: this.filterDate,
          reg_by: this.filterDataSalesNonBlacklist,
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisorNonBlacklist,
          is_blacklist: '0'
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/customer/data_approved`, { params })
        .then(response => {
          let res = response.data
          
          this.process.loadNonBlacklist = false
          
          this.listNonBlacklist = []
          this.paginationNonBlacklist = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: '',
                width: '150px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'start',
                format: 'action'
              },
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Tanggal Pengajuan',
                width: '200px',
                value: 'create_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Nama customer',
                width: '300px',
                value: 'name',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama Alias',
                width: '180px',
                value: 'name_alias',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Sales',
                width: '200px',
                value: 'reg_by',
                freeze: false,
                hide: false
              },
              
              // {
              //   text: 'Status',
              //   width: '150px',
              //   value: 'status',
              //   freeze: false,
              //   hide: false,
              //   format: 'status'
              // },
            
            ]
    
            this.listNonBlacklist = res.results.data
            this.paginationNonBlacklist = res.results.pagination
            // TokenService.saveCustomer(JSON.stringify(
            //   {
            //     sales_id: this.filterDataSales,
            //     search: this.search,
            //   }
            // ))
            // this.$store.commit("setCustomer", 
            //   {
            //     sales_id: this.filterDataSales,
            //     search: this.search,
            //     pagination: this.paginationList,
            //     supervisor_id: this.filterDataSupervisor
            //   }
            // )  

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1


            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      blacklists(item) {
        this.selected.blacklists = [item]
        this.dialog.delete = true
      },

      async toBlacklist () {
        this.message.error = ''

        this.process.delete = true

        let url = 'admin/customer/blacklist'

        await post(url, {
          data: {
            id: this.selected.blacklists[0].id,
            is_blacklist: '0'
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false
            this.process.delete = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      confirmBlacklist(item) {
        this.selected.toBlacklist = [item]
        this.dialog.addBlacklist = true
        this.tabBlacklist = 0
        this.invoiceCustomer = []
        this.jadwalCustomer = []
        this.message.errorDeleteJadwal = ''
        this.fetchJadwalCustomer()
      },

      async toAddBlacklist () {
        this.message.error = ''

        this.process.addBlacklist = true

        let url = 'admin/customer/blacklist'

        await post(url, {
          data: {
            id: this.selected.toBlacklist[0].id,
            is_blacklist: '1'
          }
        }).then(response => {
          let res = response.data

          this.process.addBlacklist = false

          if (res.status === 200) {

            this.dialog.addBlacklist = false
            this.dialog.nonBlacklist = true
            this.process.addBlacklist = false

            // Refresh both lists
            this.fetch()
            this.fetchNonBlacklist()
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports_excel () {
        this.message.error = ''

        this.process.export_excel = true

        let params = {
          
          sales_id: this.$route.params.id,
          limit: this.paginationList.row,
          page: this.paginationList.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          customer_id: this.filter.customer_id,
          search: this.search,
          category: this.filter.category,
          store_name: this.filter.store_name,
          is_blacklist: '1'
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/customer/data_approved/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>


<style>
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper { 
    overflow-y: auto; 
    height: calc(100vh - 310px); 
  }

  @media (max-width: 600px) {
    .wrapper { 
      height: calc(100vh - 280px); 
    }
  }

  @media (max-width: 960px) {
    .wrapper { 
      height: calc(100vh - 295px); 
    }
  } 

  .wrapper-dialog { 
    overflow-y: auto; 
    height: calc(70vh - 150px); 
  }

  @media (max-width: 600px) {
    .wrapper-dialog { 
      height: calc(80vh - 120px); 
    }
    
    .table th, .table td {
      font-size: 10px !important;
      padding: 4px 8px !important;
    }
  }

  @media (max-width: 960px) {
    .wrapper-dialog { 
      height: calc(75vh - 130px); 
    }
    
    .table th, .table td {
      font-size: 11px !important;
      padding: 6px 10px !important;
    }
  }

  @media (min-width: 1264px) {
    .wrapper-dialog { 
      height: calc(70vh - 180px); 
    }
  }

  .wrapper-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 

  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
  
  .jadwal-customer-summary-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.jadwal-customer-summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.jadwal-customer-list-card {
  overflow: hidden;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important; */
  background: #FFFFFF;
}

.jadwal-customer-table-wrapper {
  overflow-x: auto !important;
  overflow-y: auto;
  width: 100%;
  max-height: 400px;
  min-height: 400px;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.jadwal-customer-table-wrapper::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.jadwal-customer-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.jadwal-customer-table-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.jadwal-customer-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.jadwal-customer-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #FFFFFF;
  min-width: 1200px;
  table-layout: auto;
}

.jadwal-customer-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #FFFFFF;
}

.jadwal-customer-table thead tr {
  background: #F8F9FA;
}

.jadwal-customer-th {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #475569 !important;
  padding: 10px 12px !important;
  text-align: left !important;
  background: #f8fafc !important;
  border-bottom: 1px solid #f6f7fa !important;
  white-space: nowrap;
  position: relative;
  text-transform: capitalize;
  letter-spacing: 0.5px;
  font-size: 12px !important;
}

/* .jadwal-customer-th:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  height: 60%;
  width: 1px;
  background: #f6f7fa;
} */

.jadwal-customer-th.text-right {
  text-align: right !important;
}

.jadwal-customer-th.text-center {
  text-align: center !important;
}

.jadwal-customer-th-sticky {
  position: sticky !important;
  left: 0 !important;
  z-index: 12 !important;
  background: #f8fafc !important;
  width: 110px !important;
  min-width: 110px !important;
  max-width: 110px !important;
}

.jadwal-customer-table thead tr .jadwal-customer-th-sticky {
  background: #F8F9FA !important;
}

.jadwal-customer-td {
  font-size: 12px !important;
  color: #334155 !important;
  padding: 8px 12px !important;
  border-bottom: 1px solid #F1F5F9 !important;
  vertical-align: middle;
}

.jadwal-customer-td-sticky {
  position: sticky !important;
  left: 0 !important;
  z-index: 1 !important;
  /* box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05); */
  width: 110px !important;
  min-width: 110px !important;
  max-width: 110px !important;
}

.jadwal-customer-table tbody tr:hover .jadwal-customer-td-sticky {
  background: #F8FAFC !important;
}

.jadwal-customer-td.text-right {
  text-align: right !important;
}

.jadwal-customer-td.text-center {
  text-align: center !important;
}

.jadwal-customer-table tbody tr {
  transition: all 0.2s ease;
}

.jadwal-customer-table tbody tr:nth-child(odd) {
  background: #FFFFFF;
}

.jadwal-customer-table tbody tr:nth-child(odd) .jadwal-customer-td {
  background: #FFFFFF;
}

.jadwal-customer-table tbody tr:nth-child(odd) .jadwal-customer-td-sticky {
  background: #FFFFFF !important;
}

.jadwal-customer-table tbody tr:nth-child(even) {
  background: #f9fafc;
}

.jadwal-customer-table tbody tr:nth-child(even) .jadwal-customer-td {
  background: #f9fafc;
}

.jadwal-customer-table tbody tr:nth-child(even) .jadwal-customer-td-sticky {
  background: #f9fafc !important;
}

.jadwal-customer-table tbody tr:hover {
  background-color: #F8FAFC !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.jadwal-customer-table tbody tr:hover .jadwal-customer-td {
  background-color: #F8FAFC !important;
}

.jadwal-customer-table tbody tr:hover .jadwal-customer-td-sticky {
  background-color: #F8FAFC !important;
}

.jadwal-customer-table tbody tr.last-row .jadwal-customer-td {
  border-bottom: none !important;
}

.jadwal-customer-amount {
  /* font-weight: 600; */
  font-size: 12px;
}

.jadwal-customer-amount-primary {
  color: #000;
  /* font-weight: 600; */
  font-size: 12px;
}

.jadwal-customer-amount-warning {
  color: #000;
}

.jadwal-customer-amount-success {
  color: #000;
}

.jadwal-customer-recipient-name {
  font-weight: 500;
  color: #1E293B;
}

.jadwal-customer-date {
  color: #000;
  font-size: 13px;
}

.jadwal-customer-date-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.jadwal-customer-card {
  transition: all 0.3s ease;
}

.jadwal-customer-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.jadwal-customer-th .d-flex {
  align-items: center;
}

.jadwal-customer-th .v-icon {
  opacity: 0.8;
}

.jadwal-customer-table-wrapper {
  border-radius: 8px;
}

.jadwal-customer-table tbody tr {
  cursor: default;
}

.jadwal-customer-table tbody tr:last-child .jadwal-customer-td {
  border-bottom: none !important;
}

.blacklist-btn {
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.blacklist-btn:hover:not(:disabled) {
  background-color: #DC2626 !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35) !important;
  transform: translateY(-1px);
}

.blacklist-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.3) !important;
}

.blacklist-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.opacity-90 {
  opacity: 0.9;
}

.opacity-75 {
  opacity: 0.75;
}

/* Payment Form Dialog Styles */
.jadwal-customer-form-dialog {
  overflow: hidden;
}

.jadwal-customer-form-header {
  background: linear-gradient(135deg, #1814F3 0%, #667eea 100%);
  color: white;
}

  </style>